/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useEffect, useId, useMemo } from 'react'
import {
    Message,
} from 'semantic-ui-react'

import { useTranslation } from 'react-i18next'
import useDuplicatedCallback from '../helpers/useDeduplicatedCallback'
import { useScanningContext } from './scanning.provider'

export const useScanning = (callback = undefined) => {
    const context = useScanningContext()
    const callbackId = useId()


    const isDeviceCompatible = useMemo(() => {
        const scanningCapabilities = window?.Android?.getScanningCapabilities?.()
        return scanningCapabilities && scanningCapabilities !== 'none'
    }, [])

    const isAvailable = useMemo(() => {
        return isDeviceCompatible
    }, [isDeviceCompatible])


    // Prevent multiple callbacks in 300ms window.
    const throttledCallback = useDuplicatedCallback((barcode) => {
        callback?.(barcode)
    }, 300, [callback])


     useEffect(() => {
        if (isAvailable && callback) {
            // Register this component as using scanning
            context.registerCallback(callbackId)
            
            window.addEventListener('barcode', throttledCallback, false)
            
            return () => {
                context.unregisterCallback(callbackId);
                window.removeEventListener('barcode', throttledCallback);
            }
        }
    }, [throttledCallback, isAvailable, callback, context])

    return {isAvailable}
}


export const ScanningInformationLabel = () => {

    const {isAvailable} = useScanning()
    const [t] = useTranslation()

    return <>
        {isAvailable && <Message
          css={css`
              &.ui.message:not(:last-child) {
                  margin-bottom: 1.5rem;
              }
          `}
          icon="info"
          size="mini"
          info
          content={t('order.pickup.scan_available_label')}>
        </Message>}
    </>

}
